import React, {useEffect, useState, useRef} from 'react'
import YouTube from 'react-youtube';
import TimerTracker from '../../../utils/tracker';

const LMSPlayYT = ({playerContent, onUpdate}) => {
  
  const [youtubeId, setYoutubeId] = useState("");
  const [duration, setDuration] = useState(0);
  const [currentDuration, setCurrentDuration] = useState(0);
  const [inactiveTab, setInactiveTab] = useState(false);


  const updateProgressReport = (i) =>{
    onUpdate({
      id: playerContent.uuid,
      progress: i
    })
  }

  const onPlayerReady = (event) => {
    const playerDuration = Math.floor(event.target.getDuration());
    setDuration(playerDuration > 0 ? playerDuration : 0 )
  }

  const disableRightClick = (e) => {
    e.preventDefault();
  }

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1,
      rel: 0,            // Disable related videos at the end
      modestbranding: 1, // Removes the YouTube logo from the control bar
      controls: 1,       // Set to 0 to hide controls
      showinfo: 0,       // Hide video title and uploader info
      disablekb: 1 ,      // Disable keyboard controls
    },
  };

  function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}

  useEffect(()=>{
  let id = youtube_parser(playerContent?.assetLink || "");
  setYoutubeId(id);
  },[playerContent]);


  useEffect(() => {
    return () => {
      //  console.log("UnMount");
       currentDuration > 0 && updateProgressReport(currentDuration);
      };
    }, []);

    useEffect(() => {
      if (inactiveTab) {
        // console.log("Inactive");
        currentDuration > 0 && updateProgressReport(currentDuration);
    }
  }, [inactiveTab]);

  const handleStateChange = (event) => {
    const currentTime = event.target.getCurrentTime();
    let currentDuration = Math.floor(currentTime);
    let completionPercentage = Math.floor((currentDuration / duration) * 100);
    if(completionPercentage <= 0) return;

    setCurrentDuration(completionPercentage);
    updateProgressReport(completionPercentage);

    // switch (event.data) {
    //   case YouTube.PlayerState.PLAYING:
    //     console.log('Video is playing');
    //     break;
    //   case YouTube.PlayerState.PAUSED:
    //     console.log('Video paused');
    //     break;
    //   case YouTube.PlayerState.ENDED:
    //     console.log('Video ended');
    //     break;
    //   default:
    //     break;
    // }
  }

  return (
    <>
    <div className="quiz main-quiz-body youtube d-flex" onContextMenu={disableRightClick}>
        <YouTube 
          videoId={youtubeId} 
          opts={opts} 
          onReady={onPlayerReady} 
          onContextMenu={disableRightClick}
          onStateChange={handleStateChange}                      
        />
    </div>
    <TimerTracker setInactiveTab={setInactiveTab} />
    </>
  )
}

export default LMSPlayYT